import { Text } from "@chakra-ui/react";
import { renderRule, isParagraph } from "datocms-structured-text-utils";
import React from "react";

const paragraph = renderRule(isParagraph, ({ children, key }) => (
  <Text key={key}>{children}</Text>
));

export default paragraph;
